import { MenuItem } from "@chakra-ui/react";
import Modal from "../../../../components/Modal";
import { useUpsertConvenio } from "../hooks/useConvenio";
import ConvenioForm from "./ConvenioForm";

const EditarConvenio = ({ data }) => {
  const { mutateAsync, isPending } = useUpsertConvenio(data?._id);

  return (
    <Modal
      trigger={({ onOpen }) => (
        <MenuItem onClick={onOpen}>
          Editar
        </MenuItem>
      )}
      title={`Editar Convênio: ${data?.nomeConvenioCompleto}`}
      size="5xl"
      formId="form-convenio"
      isLoading={isPending}
    >
      {({ onClose }) => (
        <ConvenioForm
          initialData={data}
          onSubmit={async (formData) => { await mutateAsync(formData); onClose(); }}
          isLoading={isPending}
          formId="form-convenio"
          hideActions
        />
      )}
    </Modal>
  );
};

export default EditarConvenio;
